import React, { useContext, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import {
  Body,
  Container,
  FormContainer,
  MetricCard,
  MetricsContainer,
  StatusContainer,
  Title,
  WorkflowSection,
} from "./styles";
import { Button, Select, Option, Table } from "../../_core/_components";
import { AuthContext } from "../../_main/contexts/auth";
import { STATUSES } from "../serasa/acompanhamento-workflow/constants";
import { STATUS_OPTIONS } from "../ajuizamento/status-workflow";
import api from "../../_core/api";
import { useCache } from "../../_core/cache";
import { requests } from "../../requests";
import { ResumeTotal } from "../inadimplencia/relatorio/types";
import { handleErrors } from "../../_core/services/toast";
import { Shimmer } from "../../_core/_components/shimmer";
import Welcome from "../../_core/_components/welcome";
import moment from "moment";

const TableColumnsAjuizamento = [
  { label: "SHOPPING", key: "nomeShopping" },
  { label: "STATUS(WORKFLOW)", key: "nomStatusWorkflow" },
];

const TableColumnsSerasa = [
  { label: "Shopping", key: "nmShopping", orderable: true },
  { label: "Status", key: "nome", orderable: true },
];

type Profile =
  | "COBRANÇA SHOPPING"
  | "APROVADOR SHOPPING"
  | "COBRANÇA CORPORATIVA"
  | "APROVADOR HOLDING"
  | "REGUA DE COBRANÇA"
  | "RÉGUA DE COBRANÇA"
  | "ADMIN"
  | "APROVADOR SERASA"
  | "APROVADOR AJUIZAMENTO"
  | "GESTÃO ACESSO"
  | "INADIMPLENCIA";

type ProfileRules = {
  showAjuizamento: boolean;
  showSerasa: boolean;
  showInadimplencia: boolean;
  shoppingFilter: "blocked" | "portfolio" | "free" | "none";
};

const profileRules: Record<Profile, ProfileRules> = {
  "COBRANÇA SHOPPING": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "blocked",
  },
  "APROVADOR SHOPPING": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "blocked",
  },
  "COBRANÇA CORPORATIVA": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "portfolio",
  },
  "APROVADOR HOLDING": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "portfolio",
  },
  "REGUA DE COBRANÇA": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "free",
  },
  "RÉGUA DE COBRANÇA": {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "free",
  },
  ADMIN: {
    showAjuizamento: true,
    showSerasa: true,
    showInadimplencia: true,
    shoppingFilter: "free",
  },
  "APROVADOR SERASA": {
    showAjuizamento: false,
    showSerasa: true,
    showInadimplencia: false,
    shoppingFilter: "blocked",
  },
  "APROVADOR AJUIZAMENTO": {
    showAjuizamento: true,
    showSerasa: false,
    showInadimplencia: false,
    shoppingFilter: "blocked",
  },
  "GESTÃO ACESSO": {
    showAjuizamento: false,
    showSerasa: false,
    showInadimplencia: false,
    shoppingFilter: "none",
  },
  INADIMPLENCIA: {
    showAjuizamento: false,
    showSerasa: false,
    showInadimplencia: true,
    shoppingFilter: "none",
  },
};

const defaultRules: ProfileRules = {
  showAjuizamento: false,
  showSerasa: false,
  showInadimplencia: false,
  shoppingFilter: "none",
};

export function Home(): JSX.Element {
  const { id, profile, shoppings } = useContext(AuthContext);

  const shoppingsOptions = useMemo(() => {
    return _.orderBy(
      shoppings?.map((e) => ({ value: e.id, label: e.name })),
      ["label"],
      ["asc"]
    );
  }, [shoppings]);

  const rules = useMemo(() => {
    const userProfile = profile as Profile;
    return profileRules[userProfile] ?? defaultRules;
  }, [profile]);

  const disabledShoppingSelect = rules.shoppingFilter === "blocked";

  const {
    response: responseFiltersTipoMovimento,
    isLoading: isLoadingFiltersTipoMovimento,
  } = useCache({
    key: "getTipoMovimento",
    fn: requests.get("getTipoMovimento"),
  });

  const { response: responsePortfolios } = useCache({
    key: "getPortfolios",
    fn: requests.get("getPortfolios"),
  });

  const tipoContaArr = useMemo(() => {
    return responseFiltersTipoMovimento?.data
      .map((e: any) => e.codigo)
      .join(",");
  }, [responseFiltersTipoMovimento]);

  const portfolioOptions = useMemo(() => {
    const listPortfolios: Option[] = [];
    if (responsePortfolios !== undefined) {
      responsePortfolios.data.content.map((item: string) => {
        listPortfolios.push({
          value: item,
          label: item,
        });
        return null;
      });
    }
    return listPortfolios;
  }, [responsePortfolios]);

  const shouldShowWelcome = () => {
    const cutoffDate = "2026-01-01";
    const today = moment().format("YYYY-MM-DD");
    const lastShown = localStorage.getItem("welcomeShownDateSiscob");

    return moment(today).isSameOrBefore(cutoffDate) && lastShown !== today;
  };

  const [showWelcome, setShowWelcome] = useState(shouldShowWelcome());

  const [selectedShoppingAjuizamento, setselectedShoppingAjuizamento] =
    useState<Option[]>(shoppingsOptions);
  const [portfolioAjuizamento, setPortfolioAjuizamento] = useState<Option[]>(
    []
  );
  const [selectedStatusAjuizamento, setSelectedStatusAjuizamento] =
    useState<Option[]>(STATUS_OPTIONS);
  const [dataAjuizamento, setDataAjuizamento] = useState<any>();
  const [isLoadingAjuizamento, setIsLoadingAjuizamento] = useState(false);

  const [selectedShoppingSerasa, setselectedShoppingSerasa] =
    useState<Option[]>(shoppingsOptions);
  const [portfolioSerasa, setPortfolioSerasa] = useState<Option[]>([]);
  const [selectedStatusSerasa, setSelectedStatusSerasa] =
    useState<Option[]>(STATUSES);
  const [isLoadingSerasa, setIsLoadingSerasa] = useState(false);
  const [dataSerasa, setDataSerasa] = useState<any>();

  const [total, setTotal] = useState<ResumeTotal>();

  const [dataVencimento] = useState(() => {
    const dataAtual = new Date();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const ano = dataAtual.getFullYear();
    return `${mes}/${ano} - ${mes}/${ano}`;
  });

  const params = useMemo(
    () => ({
      shoppingIds: shoppingsOptions.map((e) => e.value).join(","),
      mesAnoInicio: dataVencimento.split(" - ")[0].replace("/", "-"),
      mesAnoFim: dataVencimento.split(" - ")[1].replace("/", "-"),
      codigosTipoMovimento: tipoContaArr,
      apenasParticipacao: false,
      nomeFantasia: "",
    }),
    [shoppingsOptions, dataVencimento, tipoContaArr]
  );

  const getHeader = async () => {
    try {
      const { data } = await api.get("/inadimplencia/header", { params });
      setTotal(data);
    } catch (error) {
      handleErrors(error);
    }
  };

  const getDataAjuizamento = async () => {
    try {
      setIsLoadingAjuizamento(true);
      setDataAjuizamento(undefined);
      const { data } = await api.get(
        "/workflow/ajuizamento/acoes-por-shoppping/por-status",
        {
          params: {
            idShoppings:
              rules.shoppingFilter !== "portfolio"
                ? selectedShoppingAjuizamento.map((e) => e.value).join(",")
                : undefined,
            idStatusWorkflows: selectedStatusAjuizamento
              .map((s) => s.value)
              .join(","),
            portfolio:
              rules.shoppingFilter !== "portfolio"
                ? undefined
                : portfolioAjuizamento.map((e) => e.value).join(","),
          },
        }
      );
      setDataAjuizamento(data);
    } catch (e) {
      handleErrors(e);
    }
    setIsLoadingAjuizamento(false);
  };

  const handleCloseWelcome = () => {
    const today = moment().format("YYYY-MM-DD");
    localStorage.setItem("welcomeShownDateSiscob", today);
    setShowWelcome(false);
  };

  const getDataSerasa = async () => {
    try {
      setIsLoadingSerasa(true);
      setDataSerasa(undefined);
      const { data } = await api.post(
        "workflow/serasa/serasa-shopping/acompanhar-shopping",
        {
          shoppings:
            rules.shoppingFilter !== "portfolio"
              ? selectedShoppingSerasa.map((e) => e.value)
              : undefined,
          idCiclo: "",
          codigoStatus: selectedStatusSerasa.map((e) => e.value),
          idUsuario: id,
          portfolio:
            rules.shoppingFilter !== "portfolio"
              ? undefined
              : portfolioSerasa.map((e) => e.value).join(","),
        }
      );
      setDataSerasa(data.content);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoadingSerasa(false);
  };

  useEffect(() => {
    if (!isLoadingFiltersTipoMovimento) {
      if (rules.showInadimplencia) getHeader();
      if (rules.showAjuizamento) getDataAjuizamento();
      if (rules.showSerasa) getDataSerasa();
    }
  }, [isLoadingFiltersTipoMovimento]);

  const renderedDataSerasa = useMemo(() => {
    if (dataSerasa?.length > 0) {
      return dataSerasa.map((item: any) => ({
        nmShopping: item.shopping.nomeShopping,
        quantidadeBoletos: item.quantidadeBoletos,
        quantidadeFiador: item.quantidadeFiador,
        quantidadeExcecao: item.quantidadeExcecao,
        nome: item.statusWorkflow.nome,
      }));
    }
    return [];
  }, [dataSerasa]);

  const renderMetricsContainer = useMemo(() => {
    if (total) {
      return (
        <MetricsContainer>
          <MetricCard>
            <Title>Inadimplência Bruta (R$):</Title>
            <p>
              {total?.inadimplenciaBruta.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </MetricCard>
          <MetricCard>
            <Title>Inadimplência Líquida (R$):</Title>
            <p>
              {total?.inadimplenciaLiquida.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </MetricCard>
          <MetricCard>
            <Title>Faturado</Title>
            <p>
              {total?.faturado.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </MetricCard>
        </MetricsContainer>
      );
    }
    return (
      <MetricsContainer>
        <Shimmer height="94px" />
        <Shimmer height="94px" />
        <Shimmer height="94px" />
      </MetricsContainer>
    );
  }, [total]);

  const renderTableAjuizamento = useMemo(() => {
    if (isLoadingAjuizamento) return <Shimmer height="200px" />;
    if (dataAjuizamento) {
      return <Table columns={TableColumnsAjuizamento} data={dataAjuizamento} />;
    }
    return null;
  }, [dataAjuizamento, isLoadingAjuizamento]);

  const renderTableSerasa = useMemo(() => {
    if (isLoadingSerasa) return <Shimmer height="200px" />;
    if (dataSerasa) {
      return <Table columns={TableColumnsSerasa} data={renderedDataSerasa} />;
    }
    return null;
  }, [dataSerasa, isLoadingSerasa]);

  return (
    <Container>
      <Welcome isOpen={showWelcome} closeWelcome={() => handleCloseWelcome()} />
      {rules.showInadimplencia && renderMetricsContainer}
      <StatusContainer>
        <Title>Status Workflow</Title>
        <Body>
          {rules.showAjuizamento && (
            <WorkflowSection>
              <h3>Ajuzamento</h3>
              <FormContainer>
                {rules.shoppingFilter !== "portfolio" ? (
                  <Select
                    placeholder="Shoppings"
                    state={[
                      selectedShoppingAjuizamento,
                      setselectedShoppingAjuizamento,
                    ]}
                    options={shoppingsOptions}
                    key={1}
                    disabled={disabledShoppingSelect}
                  />
                ) : (
                  <Select
                    state={[portfolioAjuizamento, setPortfolioAjuizamento]}
                    options={portfolioOptions}
                    placeholder="Portfólios"
                  />
                )}
                <Select
                  placeholder="Status"
                  state={[
                    selectedStatusAjuizamento,
                    setSelectedStatusAjuizamento,
                  ]}
                  options={STATUS_OPTIONS}
                  key={2}
                />
                <Button text="Pesquisar" onClick={getDataAjuizamento} key={3} />
              </FormContainer>
              {renderTableAjuizamento}
            </WorkflowSection>
          )}

          {rules.showSerasa && (
            <WorkflowSection>
              <h3>Serasa</h3>
              <FormContainer>
                {rules.shoppingFilter !== "portfolio" ? (
                  <Select
                    placeholder="Shoppings"
                    state={[selectedShoppingSerasa, setselectedShoppingSerasa]}
                    options={shoppingsOptions}
                    key={1}
                    disabled={disabledShoppingSelect}
                  />
                ) : (
                  <Select
                    state={[portfolioSerasa, setPortfolioSerasa]}
                    options={portfolioOptions}
                    placeholder="Portfólios"
                  />
                )}
                <Select
                  placeholder="Status"
                  state={[selectedStatusSerasa, setSelectedStatusSerasa]}
                  options={STATUSES}
                  key={2}
                />
                <Button text="Pesquisar" onClick={getDataSerasa} key={3} />
              </FormContainer>
              {renderTableSerasa}
            </WorkflowSection>
          )}
        </Body>
      </StatusContainer>
    </Container>
  );
}
